import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Plus, Trash } from '@phosphor-icons/react';
import { API } from './adminConstants';

export function AnnouncementManagement() {
  const { getAuthHeader } = useAuth();
  const [anns, setAnns] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ title: '', content: '', priority: 'normal' });

  const load = async () => { const r = await axios.get(`${API}/admin/announcements`, { headers: getAuthHeader() }); setAnns(r.data); };
  useEffect(() => { load(); }, []);

  const handleCreate = async () => {
    try {
      await axios.post(`${API}/admin/announcements`, form, { headers: getAuthHeader() });
      toast.success('Announcement created');
      setShowForm(false); setForm({ title: '', content: '', priority: 'normal' });
      load();
    } catch { toast.error('Failed'); }
  };

  const handleDelete = async (id) => {
    try { await axios.delete(`${API}/admin/announcements/${id}`, { headers: getAuthHeader() }); toast.success('Deleted'); load(); } catch { toast.error('Failed'); }
  };

  return (
    <div data-testid="announcement-management">
      <div className="flex items-center justify-between mb-6">
        <div><h1 className="font-outfit font-bold text-2xl text-slate-900">Announcements</h1></div>
        <Button onClick={() => setShowForm(!showForm)} className="bg-lime-600 hover:bg-lime-700"><Plus size={15} className="mr-1" />New Announcement</Button>
      </div>
      {showForm && (
        <div className="mb-4 bg-white rounded-xl border border-slate-200 p-6">
          <div className="space-y-3">
            <div><Label className="text-xs">Title</Label><Input value={form.title} onChange={e => setForm({...form, title: e.target.value})} data-testid="ann-title" /></div>
            <div><Label className="text-xs">Content</Label><Textarea value={form.content} onChange={e => setForm({...form, content: e.target.value})} rows={4} /></div>
            <div><Label className="text-xs">Priority</Label>
              <Select value={form.priority} onValueChange={v => setForm({...form, priority: v})}><SelectTrigger className="w-40"><SelectValue /></SelectTrigger><SelectContent><SelectItem value="low">Low</SelectItem><SelectItem value="normal">Normal</SelectItem><SelectItem value="high">High</SelectItem><SelectItem value="urgent">Urgent</SelectItem></SelectContent></Select>
            </div>
          </div>
          <div className="flex gap-3 mt-4"><Button variant="outline" onClick={() => setShowForm(false)}>Cancel</Button><Button onClick={handleCreate} className="bg-lime-600 hover:bg-lime-700" data-testid="save-ann">Publish</Button></div>
        </div>
      )}
      <div className="space-y-3">
        {anns.map(a => (
          <div key={a.id} className="bg-white rounded-xl border border-slate-200 p-5 flex justify-between">
            <div><div className="flex items-center gap-2 mb-1"><span className={`text-xs px-2 py-0.5 rounded ${a.priority === 'urgent' ? 'bg-red-100 text-red-700' : a.priority === 'high' ? 'bg-orange-100 text-orange-700' : 'bg-slate-100 text-slate-600'}`}>{a.priority}</span><span className="text-xs text-slate-400">{new Date(a.created_at).toLocaleDateString('en-GB')}</span></div><h3 className="font-medium text-slate-900">{a.title}</h3><p className="text-sm text-slate-600 mt-1 line-clamp-2">{a.content}</p></div>
            <Button variant="ghost" size="sm" onClick={() => handleDelete(a.id)} className="text-red-500 hover:text-red-700 shrink-0"><Trash size={16} /></Button>
          </div>
        ))}
      </div>
    </div>
  );
}
